module.exports = __webpack_public_path__ + "static/img/service-h5-7.1e0c0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-7.png
// module id = A2ag
// module chunks = 34